<app-breadcrumb  *ngIf="!mod" [master]="'ASF360'" [parentName]="'Tagi'" [name]="'Dodaj'"></app-breadcrumb>
<div class="tags-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!tagsFormValid || processingRequest"  [class.spinner]="processingRequest">  <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" *ngIf="!mod">
            <h3>Dodawanie Tag</h3>
          </div>

          <div fxLayout="row" *ngIf="mod">
            <h3>Edytuj Tag</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa tagu</mat-label>

                <input [formControl]="nameControl" appCapitalizeFirst matInput placeholder="Nazwa tagu"  [required]="true" >
                <mat-error *ngIf="tagForm.get('name').hasError('backendError')">{{errors.name}}</mat-error>

              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" >

            <div fxFlex="100">


                <app-dict
                  [label]="'Typ tagu'" [dictType]="'post_tag_type'"
                  [required]="true"
                  [multiple]="false"
                  [formControl]="typeControl"
                ></app-dict>


            </div>

          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="mod">

            <div fxFlex="100">

                <mat-slide-toggle fxFlex="100" color="accent" [formControl]="activeControl">Aktywny</mat-slide-toggle>

            </div>

          </div>

        </mat-card>
      </div>
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px"  *ngIf="departmentType">
        <mat-card>

          <div fxLayout="row" >
            <h3> Nagłówek</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" >
            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label> Nagłówek</mat-label>

                <input [formControl]="headerControl" appCapitalizeFirst matInput placeholder="Nagłówek"  [required]="false" >
                <mat-error *ngIf="tagForm.get('header').hasError('backendError')">{{errors.name}}</mat-error>

              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px"  *ngIf="departmentType">
        <mat-card class="partners-add-card" fxLayout="column">
            <div fxLayout="row">
              <h3>
                Użytkownicy
              </h3>
            </div>

            <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of userFormArray; index as i">
              <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
                <div fxFlex="5" class="list-counter">
                  {{i+1}}.
                </div>
                <div fxFlex="90" fxLayoutGap="10px">
                  <div fxFlex="25" >
                    <mat-form-field class="tags-add-input">
                      <mat-label>Imie i nazwisko</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Imie i nazwisko" formControlName="usersName" [required]="true">
                      <mat-error *ngIf="formGroup.get('usersName').hasError('backendError')">{{errors.name}}</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="25" >
                    <mat-form-field class="tags-add-input">
                      <mat-label>Stanowisko</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Stanowisko" formControlName="usersPosition" [required]="false">
                      <mat-error *ngIf="formGroup.get('usersPosition').hasError('backendError')">{{errors.name}}</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="25" >
                    <mat-form-field class="tags-add-input">
                      <mat-label>Numer telefonu</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Numer telefonu" formControlName="usersPhone" [required]="true">
                      <mat-error *ngIf="formGroup.get('usersPhone').hasError('backendError')">{{errors.name}}</mat-error>

                    </mat-form-field>
                  </div>
                  <div fxFlex="25" >
                    <mat-form-field class="tags-add-input">
                      <mat-label>Email</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Email" formControlName="usersEmail" [required]="true">
                      <mat-error *ngIf="formGroup.get('usersEmail').hasError('backendError')">{{errors.name}}</mat-error>

                    </mat-form-field>
                  </div>
                </div>
                <div fxFlex="5"  fxLayoutGap="15px">
                  <div class="list-remove-button">
                    <button (click)="removeUsers(i)" mat-icon-button color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

            </div>

            <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
              </span>
              <button (click)="addUsers(true)" mat-stroked-button color="primary">
                <mat-icon>add_box</mat-icon> <span> Dodaj</span>
              </button>
            </div>
        </mat-card>
      </div>

      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px"*ngIf="insuranceType ">
        <mat-card class="partners-add-card" fxLayout="column">
          <div fxLayout="row">
            <h3>
              Grafiki
            </h3>
          </div>


          <div fxLayout="column" fxFlex="100" *ngFor="let formGrou of graphicsFormArray; index as i">
            <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGrou" fxLayoutAlign="space-around center">
              <div fxFlex="5" class="list-counter">
                {{i+1}}.
              </div>
              <div fxFlex="90" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                <div fxFlex="40" >

                    <app-file-drag-and-drop fxFlex="94" [maxSize]="maxSize" [multiple]="false" [generateOutput]="true" acceptMime="image/png, image/jpeg" (fileSelected)="onFileChange($event, i)"></app-file-drag-and-drop>


                </div>
                <div fxFlex="50" >

                  <app-detail  header=" TYP" [value]="formGrou.get('graphicsType').value"></app-detail>


<!--                  <mat-form-field class="tags-add-input">-->
<!--                    <mat-label>TYP</mat-label>-->
<!--                    <input appCapitalizeFirst matInput placeholder="type" formControlName="graphicsType" [required]="true" [disabled]="true">-->
<!--                    <mat-error *ngIf="formGrou.get('graphicsType').hasError('backendError')">{{errors.name}}</mat-error>-->
<!--                  </mat-form-field>-->
                </div>
              </div>
              <div fxFlex="5"  fxLayoutGap="15px">
                <div class="list-remove-button">
                  <button (click)="removeGraphics(i)" mat-icon-button color="warn">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>

          </div>

        </mat-card>
      </div>

      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px"*ngIf="postType">
        <mat-card class="partners-add-card" fxLayout="column">
          <div fxLayout="row">
            <h3>
              Grafika
            </h3>
          </div>


          <div fxLayout="column" fxFlex="100" *ngFor="let formGrou of graphicsFormArray; index as i">
            <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGrou" fxLayoutAlign="space-around center">

              <div fxFlex="90" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                <div fxFlex="100" >

                  <app-file-drag-and-drop fxFlex="94" [maxSize]="maxSize" [multiple]="false" [generateOutput]="true" acceptMime="image/png, image/jpeg" (fileSelected)="onFileChange($event, i)"></app-file-drag-and-drop>


                </div>
              </div>
              <div fxFlex="5"  fxLayoutGap="15px">
                <div class="list-remove-button">
                  <button (click)="removeGraphics(i)" mat-icon-button color="warn">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>

          </div>

        </mat-card>
      </div>


    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!tagsFormValid || processingRequest"  [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>
</div>

